export class Project {
  constructor(
    public id: string,
    public title: string,
    public description: string,
    public groupId: string,
    public groupName: string,
    public piUserId: string,
    public piName: string,
    public state: string,
    public createdAt: string,
    public completedAt?: string,
    public userRole?: 'PI' | 'RESEARCHER' | 'NONE',
    public paperCount?: number,
    public exclusionCriteria?: string,
    public inclusionCriteria?: string,
    public cohenKappaThreshold?: number | null,
  ) {}
}
